import { Injectable } from '@angular/core';
import LogRocket from 'logrocket';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root',
})
export class LogRocketService {
  private initialized = false;

  constructor(private readonly configService: ConfigService) {}

  init(): void {
    if (!this.configService.ENABLE_LOGROCKET || !this.configService.LOGROCKET_APP_ID) {
      return;
    }

    if (this.initialized) {
      return;
    }

    LogRocket.init(this.configService.LOGROCKET_APP_ID);
    this.initialized = true;
  }

  identify(rut: string): void {
    if (!this.initialized) {
      return;
    }

    LogRocket.identify(rut);
  }
}
